export interface TwoFactorAuthUpdateRequestModel {
  google2FAEnabled: boolean;
  email2FAEnabled: boolean;
}
